import { render, staticRenderFns } from "./Incidents.vue?vue&type=template&id=690f4890&scoped=true&"
var script = {}
import style0 from "./Incidents.vue?vue&type=style&index=0&id=690f4890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690f4890",
  null
  
)

export default component.exports